// extracted by mini-css-extract-plugin
export default {"wrapper":"Step7_wrapper__qtu1h"};